// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-progress{position:fixed;top:0;height:2px;width:0;opacity:1;transition:width .1s,opacity .4s;z-index:999999}[dir] .nuxt-progress{background-color:#000}[dir=ltr] .nuxt-progress,[dir=rtl] .nuxt-progress{left:0;right:0}.nuxt-progress.nuxt-progress-notransition{transition:none}[dir] .nuxt-progress-failed{background-color:red}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
